<template>
    <div class="row">
      <div class="col-md-6 col-lg-7 col-xl-8">
        <card class="card mt-3">
          <div class="card-body">
            <h4 class="card-title mb-4">Account Info</h4>
            <div class="form-group">
              <label class="control-label" for="firstname_input">First Name</label>
              <input class="form-control" id="firstname_input" type="text" v-model.trim="user.firstName" required>
            </div>
            <div class="form-group">
              <label class="control-label" for="lastname_input">Last Name</label>
              <input class="form-control" id="lastname_input" type="text" v-model.trim="user.lastName" required>
            </div>
            <div class="form-group">
              <label class="control-label" for="phone_input">Contact Phone</label>
              <input class="form-control" id="phone_input" type="text" v-model.trim="user.phone" required>
            </div>
            <div class="form-group">
              <label class="control-label" for="position_input">Job Title</label>
              <input class="form-control" id="position_input" type="text" v-model.trim="user.position" required>
            </div>
          </div>
          <div class="">
            <div class="text-center">
              <button :class="{btn:true, 'btn-success':true, 'cursor-forbidden': !actions.canUpdateUser}" @click="saveBasicInfo" :disabled="!actions.canUpdateUser || savingBasicInfo">Save<span v-if="savingBasicInfo">...</span></button>
              <div v-if="basicInfoErrorMsg !== ''" class="text-danger mt-1">{{ basicInfoErrorMsg }}</div>
            </div>
          </div>
        </card>
      </div>
      <div class="col-md-6 col-lg-5 col-xl-4">
        <card class="card mt-3">
          <div class="card-body">
            <h4 class="card-title mb-4">Login Info</h4>
            <div class="form-group">
              <label class="control-label" for="email_input">Email</label>
              <input class="form-control" id="email_input" type="email" :value="user.email" required disabled>
              <div class="text-center mt-2"><a href="javascript:void(0);" @click="resetEmail.show=!resetEmail.show;">reset email</a></div>
              <div v-show="resetEmail.show">
                <label class="control-label" for="new_email_input">New Email</label>
                <input class="form-control" id="new_email_input" type="email" v-model="resetEmail.email" required>
                <label class="control-label mt-2" for="new_email2_input">Confirm new email</label>
                <input class="form-control" id="new_email2_input" type="email" v-model="resetEmail.email2" required>
                <div class="text-center">
                  <button class="btn btn-success mt-2" @click="sendResetEmail">Save<span v-if="sendingResetEmail">...</span></button>
                  <div v-if="resetEmail.errorMsg !== ''" class="text-danger mt-1">{{ resetEmail.errorMsg }}</div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="control-label" for="password_input">Password</label>
              <input class="form-control" id="password_input" type="password" :value="'*****'" required disabled>
              <div class="text-center mt-2"><a href="javascript:void(0);" @click="resetPassword">reset password</a></div>
            </div>
          </div>
        </card>
      </div>
    </div>
</template>
<script>
import Api from "../api";
export default {
  components: {
    
  },
  data() {
    return {
      basicInfoErrorMsg: "",
      savingBasicInfo: false,
      user: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        position: "",
      },
      resetEmail: {
        show: false,
        errorMsg: "",
        email: "",
        email2: ""
      },
      sendingResetEmail: false,

      actions: {
        canUpdateUser: this.$root.canUserDo(['user_update'])
      }
    };
  },
  mounted() {
    this.getBasicInfo ();
  },
  methods: {
    getBasicInfo () {
      Api.send("GET", "/user/basic_info", {}, false)
        .then((response) => {
          this.user.email = response.data.email;
          this.user.firstName = response.data.firstName;
          this.user.lastName = response.data.lastName;
          this.user.phone = response.data.phone;
          this.user.position = response.data.position;
        })
        .catch((err) => {
          this.$root.notifyy('danger', err.msg);
        })
        .finally(() => {
          
        });
    },
    saveBasicInfo () {
      this.basicInfoErrorMsg = "";
      if (this.user.firstName === "" || this.user.lastName === "" || this.user.phone === "" || this.user.position === "") {
        this.basicInfoErrorMsg = "All fields are obligatory";
        return false;
      }

      this.savingBasicInfo = true;
      Api.send("PUT", "/user/update", {firstName: this.user.firstName, lastName: this.user.lastName, phone: this.user.phone, position: this.user.position}, false)
      .then((response) => {
        this.basicInfoErrorMsg = "";
        this.$root.notifyy('success', response.msg);
        let loggedUser = this.$root.getLoggedUser();
        loggedUser.first_name = this.user.firstName;
        loggedUser.last_name = this.user.lastName;
        this.$root.setLoggedUser(loggedUser);
      })
      .catch((err) => {
        this.basicInfoErrorMsg = err.msg;
      })
      .finally(() => {
        this.savingBasicInfo = false;
      });
    },
    sendResetEmail () {
      if (this.sendingResetEmail) {
        return false;
      }
      this.resetEmail.errorMsg = "";
      if (this.resetEmail.email === "" || this.resetEmail.email2 === "") {
        this.resetEmail.errorMsg = "All fields are obligatory";
        return false;
      }
      if (this.resetEmail.email2 !== this.resetEmail.email) {
        this.resetEmail.errorMsg = "Please confirm your email correctly";
        return false;
      }
      if (confirm('You will be logged out for security reasons and then we will send you the link to verify your new email address. Do you want to proceed?')) {
        this.sendingResetEmail = true;
        Api.send("POST", "/user/reset/email/send", {email: this.resetEmail.email}, false)
          .then((response) => {
            this.resetEmail.errorMsg = "";
            this.$root.deleteLoggedUser();
            this.$router.push({path:'reset_email_send_success'});
          })
          .catch((err) => {
            this.resetEmail.errorMsg = err.msg;
          })
          .finally(() => {
            this.sendingResetEmail = false;
          });
      }
    },
    resetPassword () {
      if (confirm('You will be logged out for security reasons and you will immediately be sent to the Reset Password page. Do you want to proceed?')) {
        this.$root.deleteLoggedUser();
        this.$router.push({path:'reset_password'});
      }
    }
  },
};
</script>
<style scoped>
.cursor-forbidden {
  cursor: not-allowed;
}
</style>
